// AccessLogs.js — Logs de acesso (auditoria), visíveis apenas para admin (P7).
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import API_URL from './config';
import './AccessLogs.css';

const ACTION_LABELS = {
  'VIEW_QUEUE_REPORT': 'Relatório de filas',
  'download_recording': 'Download de gravação',
  'list_files': 'Listagem de arquivos',
  'EXPORT_QUEUE_REPORT_CSV': 'Export CSV'
};

function formatDate(value) {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

function AccessLogs({ token }) {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const resp = await axios.get(`${API_URL}/access-logs?limit=200`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLogs(resp.data.logs || []);
      setTotal(resp.data.total || 0);
    } catch (e) {
      setError(`Erro ao carregar logs: ${e.response?.data?.message || e.message}`);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchLogs();
  }, [fetchLogs]);

  return (
    <div className="accessLogsContainer">
      <h1 className="pageTitle">Logs de Acesso</h1>
      <p className="accessLogsHint">
        Auditoria de acessos (downloads, relatórios e listagens). {total} registro(s) no total.
      </p>

      <div className="controlsSection">
        <button onClick={fetchLogs} disabled={loading} className="button buttonPrimary">
          {loading ? 'Carregando...' : 'Atualizar'}
        </button>
      </div>

      {error && <div className="message messageError">{error}</div>}

      {!loading && logs.length === 0 && (
        <div className="noDataMessage">Nenhum log de acesso registrado.</div>
      )}

      {logs.length > 0 && (
        <div className="tableContainer">
          <table className="extensionsTable">
            <thead>
              <tr>
                <th>#</th>
                <th>Usuário</th>
                <th>Ação</th>
                <th>Recurso</th>
                <th>IP</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id}>
                  <td>{log.id}</td>
                  <td>{log.username || '-'}</td>
                  <td>{ACTION_LABELS[log.action] || log.action || '-'}</td>
                  <td className="accessLogsResource">{log.resource_accessed || '-'}</td>
                  <td>{log.ip_address || '-'}</td>
                  <td>{formatDate(log.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AccessLogs;
